import { render, staticRenderFns } from "./EditCouponValidUntilModal.vue?vue&type=template&id=f481b058"
import script from "./EditCouponValidUntilModal.vue?vue&type=script&lang=js"
export * from "./EditCouponValidUntilModal.vue?vue&type=script&lang=js"
import style0 from "./EditCouponValidUntilModal.vue?vue&type=style&index=0&id=f481b058&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports